export const TIMETABLE_WEEKLY = '/api/v1/timetables/weekly';
export const TIMETABLE_WORKING_TIME_DAILY = '/api/v1/timetables/working-time/daily';
export const WORKING_TIME = '/api/v1/working-time';
export const TIMETABLE_EVIDENCE_WORKING_TIME = '/api/v1/working-time/summary';
export const TIMETABLE_EVIDENCE_WORKING_TIME_REPORT = '/api/v1/reports/working-time/summary';
